import axios from "axios";
import { APP_CONFIG } from "../config/APP_CONFIG";
import { Auth } from "aws-amplify";

import { SuccessHandlerHelper } from "./SuccessHandlerHelper";
import { ErrorHandlerHelper } from "./ErrorHandlerHelper";

const successCodes = [200, 204, 201];

export class ApiHelper {
  _portalGateway;
  _apiVersion;

  constructor() {
    this._portalGateway = APP_CONFIG.API_URL;
  }

  setHost = (host) => {
    this._portalGateway = host;
  };

  setApiVersion = (version) => {
    this._apiVersion = version;
  };

  async FetchFromServer(
    endpoint,
    method = "GET",
    queryOptions = undefined,
    body = undefined,
    headers = {}
  ) {
    let url = `${this._portalGateway}${endpoint}`;
    console.log("dieie", headers);
    if (!headers?.Authorization && !endpoint.includes("/companies/domain")) {
      console.log("No auth header, fetching token...");
      const session = await Auth.currentSession();
      const token = session.getIdToken().getJwtToken();
      headers = { ...headers, Authorization: `Bearer ${token}` }
    }
    const config = {
      headers: {
        "Cache-Control": "no-cache",
        "Content-Type": "application/json",
        Expires: "0",
        Pragma: "no-cache",
        ...headers,
      },
      withCredentials: true,
      params: queryOptions,
      cancelToken: new axios.CancelToken((cancel) => {
        this.cancelRequest = cancel;
      }),
    };

    try {
      let response;

      if (method.toUpperCase() === "GET") {
        response = await axios.get(url, config);
      } else {
        response = await axios.request({
          url,
          method: method.toUpperCase(),
          data: body,
          ...config,
        });
      }

      const contentType = response.headers["content-type"];

      if (!successCodes.includes(response.status)) {
        let errorData;

        if (contentType && contentType.includes("application/json")) {
          errorData = response.data;
        } else {
          errorData = response.statusText;
        }

        const errorObject = {
          code: response.status,
          data: errorData,
        };

        throw errorObject;
      }

      let data;

      if (contentType && contentType.includes("application/json")) {
        data = new SuccessHandlerHelper(response.data);
      } else {
        data = new SuccessHandlerHelper(response.data);
      }

      return data.data;
    } catch (err) {
      if (axios.isCancel(err)) {
        // Request canceled
        return { isError: false };
      }

      if (
        (err.response?.status === 401 || err.response?.status === 403) &&
        typeof window !== "undefined"
      ) {
        const currentPath = window.location.pathname;
        if (
          !currentPath.includes("/login") &&
          !currentPath.includes("/reset-password")
        ) {
          window.location.href = "/login";
        }
      }

      const errorHelper = new ErrorHandlerHelper(err);

      return errorHelper.errorObject;
    }
  }

  cancelRequest = () => {
    if (this?.cancelRequest) {
      this?.cancelRequest();
    }
  };
}
